import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { UrlProviderService } from '../general';

@Injectable({
    providedIn: 'root',
})
export class ContactService {

    constructor(private urlProviderService: UrlProviderService, private httpClient: HttpClient) {
    }

    public sendEmail(name: string, email: string, phone: string, message: string): Observable<any> {
        return this.httpClient.post<any>(`${this.urlProviderService.ApiUrl}/system/contacts/email?name=${name}&email=${email}&phone=${phone}&message=${message}`,
            {reportProgress: true}).pipe(retry(2));
    }
}
